import login from '../login'
/* eslint import/no-anonymous-default-export: [2, {"allowArray": true}] */
export default [...login.sagas]
